export const ActionTypes = {
    AddToWaitlistRequested: 'ADD_TO_WAITLIST_REQUESTED',
    AddToWaitlistRejected: 'ADD_TO_WAITLIST_REJECTED',
    AddToWaitlistFulfilled: 'ADD_TO_WAITLIST_FULFILLED',
    WaitlistCountFetched: 'WAITLIST_COUNT_FETCHED',
    FetchUserCount: 'FETCH_USER_COUNT',
    WaitlistUserCountAddSuccessful: 'WAITLIST_COUNT_ADD_SUCCESS',
    WaitlistUserCountAddFailed: 'WAITLIST_COUNT_ADD_FAILED'
  };
  export default ActionTypes;



// WEBPACK FOOTER //
// ./src/waitlist/action-types.js